import Cookies from 'js-cookie';
import { DEFAULT_REDIRECT_URL } from 'dashboard/constants/globals';
import { frontendURL } from 'dashboard/helper/URLHelper';
import { getOnboardingRoutePath } from 'dashboard/helper/OnboardingHelper';

export const hasAuthCookie = () => {
  return !!Cookies.get('cw_d_session_info');
};

const getSSOAccountPath = ({ ssoAccountId, user }) => {
  const { accounts = [], account_id = null } = user || {};
  const ssoAccount = accounts.find(
    account => account.id === Number(ssoAccountId)
  );
  let accountPath = '';
  if (ssoAccount) {
    accountPath = `accounts/${ssoAccountId}`;
  } else if (accounts.length) {
    // If the account id is not found, redirect to the first account
    const accountId = account_id || accounts[0].id;
    accountPath = `accounts/${accountId}`;
  }
  return accountPath;
};

const getAccountId = ({ ssoAccountId, user }) => {
  const { accounts = [], account_id = null } = user || {};
  const ssoAccount = accounts.find(
    account => account.id === Number(ssoAccountId)
  );

  if (ssoAccount) {
    return ssoAccountId;
  }
  if (accounts.length) {
    return account_id || accounts[0].id;
  }
  return null;
};

const capitalize = str =>
  str
    .split(/[._-]+/)
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');

export const getCredentialsFromEmail = email => {
  const [localPart, domain] = email.split('@');
  const namePart = localPart.split('+')[0];
  return {
    fullName: capitalize(namePart),
    accountName: capitalize(domain.split('.')[0]),
  };
};

export const getLoginRedirectURL = ({
  ssoAccountId,
  ssoConversationId,
  user,
}) => {
  const accountPath = getSSOAccountPath({ ssoAccountId, user });

  if (accountPath) {
    // Check if onboarding is completed
    const { onboarding } = user || {};
    const isOnboardingCompleted = onboarding?.completed;
    const lastStep = onboarding?.last_step;

    // If onboarding is not completed and no SSO conversation, redirect to onboarding
    if (!isOnboardingCompleted && !ssoConversationId) {
      const accountId = getAccountId({ ssoAccountId, user });
      const routePath = getOnboardingRoutePath(lastStep || 'select_activity');
      return frontendURL(`accounts/${accountId}/onboarding/${routePath}`);
    }

    // Otherwise, proceed with normal redirect
    if (ssoConversationId) {
      return frontendURL(`${accountPath}/conversations/${ssoConversationId}`);
    }
    return frontendURL(`${accountPath}/dashboard`);
  }
  return DEFAULT_REDIRECT_URL;
};
